export const projectData = [
    {
        name:'mNeme (flashcards application)', 
        role: 'Full Stack', 
        frontend:'https://github.com/Lambda-School-Labs/flashcards-fe', 
        backend:'https://github.com/Lambda-School-Labs/flashcards-be', 
        deployedLink: 'https://mneme-flashcards.netlify.com/',
        description: 'mNeme is a flashcards application intended to aid students in their studies. Users can create, edit, remove, and archive their decks and flashcards in this app. I was a full stack developer on this project, working in a cross functional team of web developers, UX designers, and mobile developers.',
        technologies: ["Node.js", "Express.js", "Cloud Firestore", "React.js", "Redux", "SCSS"],
        coverImage: '../../assets/mNeme.jpg'
        
    },
    // {
    //     name:'Treasure Hunter (Desktop Only)', 
    //     role:'Full Stack', 
    //     frontend: 'https://github.com/WilliamBerlin76/treasure-hunt',
    //     backend: 'https://github.com/WilliamBerlin76/cs_bw2_be',
    //     deployedLink:'https://treasurehunter.netlify.com/',
    //     description: 'Treasure hunter is a client for the Lambda Treasure Hunt challenge. As a Treasure hunter, you traverse an unknown map, building it as you go. You may encounter items, shrines, or even other players on your journy. The goal is to mine a Lambda Coin from a block chain, but to find the coin, you must follow the clues. For this challenge, I created the client with React.js, and stored my graph of the map on a PostgreSQL database with a Node.js backend. This project includes implementations of breadth-first-search, depth-first-traversal, and blockchain proof-of-work algorithms.',
    
    // },
    
    // {
    //     name:'Ant Adventure (Desktop Only)', 
    //     role:'Front End React', 
    //     githubLink:'https://github.com/CS26-Team-PleaseComeToBrazil-Mud-Game', 
    //     deployedLink:'https://ant-adventure.now.sh/',
    //     description: 'Ant adventure is a simple maze adventure game where the player is an ant traversing the vast maze of an ant hill. The backend was built with Python3 and Django, and the frontend was built using React.js.',
        
    // },
    {
        name:'Snake!', 
        role:'HTML5, JavaScript', 
        githubLink:'https://github.com/WilliamBerlin76/snake', 
        deployedLink:'https://thebigsnake.netlify.app',
        description: "This is a classic snake game replica created with vanilla JavaScript. Play as a snake as you try to eat the fruit laid out across the map. The more you eat, the longer you get, and the faster you move. Don't run into the walls, or yourself! Have fun!",
        technologies: ["HTML5 Canvas", "JavaScript", "CSS"],
        coverImage: '../../assets/Snake.jpg'
    },
    {
        name:'Goal Keeper', 
        role:'Full Stack (solo project)', 
        frontend:'https://github.com/WilliamBerlin76/goal-keeper',
        backend: 'https://github.com/WilliamBerlin76/node-goals', 
        deployedLink:'https://goal-keeper.netlify.app',
        description: 'This is a goal setting web application designed to help users set and achieve their goals. Users can organize their goals into different categories, and list the steps they will take to achieve their goal. I worked solo on this project as a full stack developer.',
        technologies: ["Node.js", "Express.js", "PostgreSQL", "React.js", "Redux", "SCSS"],
        coverImage: '../../assets/Goal-Keeper.jpg'
    },
    {
        name:'Guidr', 
        role:'Front End React', 
        githubLink: 'https://github.com/Build-Week-FT-Guidr', 
        deployedLink:'https://guidr.now.sh/',
        description: 'Guidr is an app that lets outdoor guides record their journeys to build their outdoor resume. Using this web app, outdoor guides can add, edit, and delete trips to and from their trip record. I worked as a frontend developer on a small team for this project.',
        technologies: ["React.js", "Context", "SCSS"],
        coverImage: '../../assets/Guidr.jpg'
    },
    // {
    //     name:'Weight Lifting Journal', 
    //     role: 'Back End Node.js', 
    //     backend:'https://github.com/Build-Week-Weight-Lifiting-Journal/Back-end',
    //     deployedLink: 'https://weight-lifiting-journal.netlify.com/',
    //     description: 'Weight Lifting Journal is an app designed to help weight lifters keep track of their exercises. Users can create, edit, and delete their exercises, and add exercises to a workout. The frontend was created with React.js, and the backend uses Node.js with a PostgreSQL database.',
        
    // },
   
    // {
    //     name:'Essentialism', 
    //     role:'Front End React', 
    //     githubLink:'https://github.com/Build-Week-Essentialism-2/Essentialism-FE', 
    //     deployedLink: 'https://app-essentialism.netlify.com/',
    //     description: 'Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum',
        
    // },
    // {name:'Expat Journal', role:'Landing Page UI', githubLink:'https://github.com/ExpatJournal/Marketing-Page-William-Berlin', deployedLink: 'https://pensive-euler-ed7f27.netlify.com/'},
    // {name:'Naruto Filler List', role:'Solo project - React/Redux', githubLink:'https://github.com/WilliamBerlin76/React-Redux-App', deployedLink:'https://react-redux-app-49lkdn9dv.now.sh/'},
    // {name:'', githubLink:''}
]